import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/files/:fileId' }

type Params = { fileId: FileId }
type Body = never
type Query = { thumbnail?: boolean; doNotRedirect?: boolean; includeEtag?: boolean }
// For the redirect
type Output = string | { downloadUrl: string; etag: Nullable<string> }

export type GetFileEndpoint = Endpoint<Params, Body, Query, Output>

export const getFileRequest = (request: Request, args: RequestArgs<GetFileEndpoint>) =>
    request<GetFileEndpoint>(route, args)
